export default __webpack_public_path__ + "static/2-1b6f7e5f5361e2b9a1e76692c68cd229.jpeg";